module.exports = __webpack_public_path__ + "img/list icon.da5e4b7a.svg";